import { ReactElement } from 'react';
import { SeatingPlanViewer } from '@mapado/seating';
import SeatConfigSelectorContainer from '../SeatConfigSelector';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoConfig(): ReactElement {
  const seatConfigId = useQueryNumberParam('seatConfigId', 103);

  return (
    <>
      <h3>Configuration de salle</h3>

      <SeatConfigSelectorContainer />
      <SeatingPlanViewer key={seatConfigId} seatConfigId={seatConfigId} />
    </>
  );
}
